import { motion } from 'framer-motion';
import ProductLayer from '../ProductLayer';
import { useBreakpoint } from '../../hooks/useBreakpoint';

const ProductSection = ({ productRef, cardSpread }) => {
  const { isMobile, isTablet } = useBreakpoint();

  return (
    <section
      ref={productRef}
      style={{
        minHeight: isMobile ? 'auto' : '160vh',
        position: 'relative',
        padding: isMobile ? '60px 20px' : '80px 16px',
      }}
    >
      <div
        style={{
          position: isMobile ? 'relative' : 'sticky',
          top: 0,
          height: isMobile ? 'auto' : '100vh',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <div style={{ width: '100%', maxWidth: 1000, margin: '0 auto' }}>
          <motion.div
            style={{ marginBottom: 40 }}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <p
              className="font-mono"
              style={{
                fontSize: isMobile ? 9 : 10,
                color: '#00FF41',
                textTransform: 'uppercase',
                letterSpacing: '0.3em',
                marginBottom: 8,
              }}
            >
              PROTOCOL_ARCHITECTURE
            </p>
            <h2
              style={{
                fontSize: 'clamp(20px, 4vw, 32px)',
                fontWeight: 600,
                letterSpacing: '-0.02em',
              }}
            >
              Three Layers of Defense.
            </h2>
          </motion.div>
          <div
            style={{
              position: 'relative',
              height: isMobile ? 'auto' : 400,
              minHeight: isMobile ? '800px' : 400,
              marginLeft: isMobile ? 0 : isTablet ? '5%' : '10%',
            }}
          >
            {['UNTRACKABLE', 'INVISIBLE', 'UNBREAKABLE'].map((title, i) => (
              <ProductLayer key={title} title={title} index={i} scrollProgress={cardSpread} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProductSection;
